<template>
  <div class="wptv-header">
    <div
      ref="header"
      class="header">
      <slot />
    </div>
    <!-- when sticked height offset is set to header height to have a correct scroll effect when 'un-sticked'
          otherwise offset height is 0
    -->
    <div ref="offset" />
  </div>
</template>

<script>
export default {
  name: 'WptvHeader',
  props: {
    sticky: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      top: 0,
      initialPosition: 0,
      isSticked: false
    }
  },
  watch: {
    isSticked (/* Boolean */bool) {
      // styles are modified in js to avoid chrome bug when scrolling top
      if (bool) {
        this.$refs.offset.style.height = `${this.$refs.header.getBoundingClientRect().height}px`
        this.$refs.header.style.width = `${this.$refs.header.getBoundingClientRect().width}px`
        this.$refs.header.style.position = 'fixed'
        this.$refs.header.style.top = '0'

        this.$emit('sticked')
      } else {
        this.$refs.offset.style.height = '0px'
        this.$refs.header.style.position = 'relative'

        this.$emit('un-sticked')
      }
    }
  },
  mounted () {
    // /!\ we should add a watch on sticky prop in case it needs to change dynamicaly
    if (this.sticky) {
      this.resize()
      this.initialPosition = window.pageYOffset
      document.addEventListener('scroll', this.scroll)
      window.addEventListener('resize', this.resize)
    }
  },
  beforeDestroy () {
    document.removeEventListener('scroll', this.scroll)
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    resize () {
      const topOffset = this.isSticked ? this.$refs.offset.getBoundingClientRect().top : this.$refs.header.getBoundingClientRect().top

      this.top = window.pageYOffset + topOffset
    },
    scroll () {
      // if scroll top, stick the menu to top until it reaches its original position (this.top)
      this.isSticked = window.pageYOffset > this.top
      this.initialPosition = window.pageYOffset
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.wptv-header {
  .header {
    background-color: #ffffff;
    z-index: 98;
  }
}
</style>
